import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Misma hoja de ruta que /hoja-de-ruta/$token, pero bajo /portal/…: el Portal instalado como app tiene
// `scope: "/portal"`, así que un enlace fuera de ese prefijo se abre en Safari en vez de quedarse
// dentro de la app. Desde el Panel del Portal ("Tu hoja de ruta") se enlaza acá.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/portal/hoja-de-ruta/$token",
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: lazyRouteComponent(() => import("./hoja-de-ruta-page"), "HojaDeRutaPage"),
});
